<template>
  <el-dialog custom-class="renyuanDialog" width="800px" :visible.sync="showGroup" :before-close="handleClose"
    :show-close="false" :append-to-body="appendToBody">
    <div slot="title" class="dialog-title">
      <span>人员选择</span>
      <div>
        <el-button @click="handleClose" size="mini">取 消</el-button>
        <el-button style="margin-right: 10px;" type="primary" @click="saveBtn" size="mini">确 定</el-button>
      </div>
    </div>
    <div class="dialog-body">
      <el-tabs type="border-card" @tab-click="tabChange">
        <el-tab-pane>
          <span slot="label">
            <i class="iconfont icon-zuijin"></i> 人员选择
          </span>
          <select-tab-one ref="morePerTab1" :selectedList="selectedList" @addPersonFun="addPersonFun"
            @deletePersonFun="deletePersonFun" @selectAllPerFun="selectAllPerFun" @cancelAllPerFun="cancelAllPerFun"
            :onlyPeople="onlyPeople" :sourceInit="sourceInit" :orgOptions="orgOptions" :radio="radio"
            @radioSelect="radioSelect"></select-tab-one>
        </el-tab-pane>
        <!-- <el-tab-pane>
          <span slot="label">
            <i class="iconfont icon-xuanzezuzhi"></i> 按组织筛选
          </span>
          <select-tab-two
            :selectedList="selectedList"
            @addPersonFun="addPersonFun"
            @deletePersonFun="deletePersonFun"
            @selectAllPerFun="selectAllPerFun"
            @cancelAllPerFun="cancelAllPerFun"
            :onlyPeople="onlyPeople"
            :sourceInit="sourceInit"
            :orgOptions="orgOptions"
          ></select-tab-two>
        </el-tab-pane> -->
        <!-- <el-tab-pane>
          <span slot="label">
            <i class="iconfont icon-zidingyiqunzu"></i> 自定义群组
          </span>
          <select-tab-three
            @initTab1Normal="initTab1Normal"
            :selectedList="selectedList"
            @addPersonFun="addPersonFun"
            @deletePersonFun="deletePersonFun"
            @selectAllPerFun="selectAllPerFun"
            @cancelAllPerFun="cancelAllPerFun"
            :sourceInit="sourceInit"
            :orgOptions="orgOptions"
          ></select-tab-three>
        </el-tab-pane> -->
      </el-tabs>
      <div class="selectedBox" :style="computedStyle">
        <div class="arrowBtn" :class="openSign ? 'arrowBtnBt' : 'arrowBtnUp'" @click="openTab">
          <!--           <i class="iconfont icon-jiantoushang" v-if="!openSign"></i>
          <i class="iconfont icon-jiantou1" v-else></i>-->
        </div>
        <div class="clearBtn">
          <i class="iconfont icon-qingkong1" @click="clearSelected"></i>
        </div>
        <div class="selectedWild">
          <div class="selectedCardBox" :style="computedWild">
            <div class="selectedCardWild" v-for="(item, index) in selectedList" :key="index">
              <selected-card :itemData="item" :title="computedTitle(item)"></selected-card>
              <i class="deleIcon" @click.stop="deleteItem(item)">&times;</i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import selectTabOne from './selectTab1';
// import selectTabTwo from './selectTab2';
// import selectTabThree from './selectTab3';
import selectedCard from './selectedCard';
import { getSourceMap } from '@/api/index';
export default {
  props: {
    showGroup: {
      type: Boolean
    },
    initData: {
      type: Array,
      default: () => []
    },
    onlyPeople: {
      type: Boolean,
      default: false
    },
    sourceInit: {
      type: String,
      default: 'PS'
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    },
  },
  components: {
    selectTabOne: selectTabOne,
    // selectTabTwo: selectTabTwo,
    // selectTabThree: selectTabThree,
    selectedCard: selectedCard
  },
  created() {
    let arr = [];
    this.initData.map(item => {
      let obj = Object.assign({}, item);
      arr.push(obj);
    });
    this.selectedList = arr;
    this.init();
  },
  data() {
    return {
      openSign: false,
      selectedList: [],
      loading: false,
      orgOptions: []
    };
  },
  computed: {
    computedStyle() {
      return { height: (this.openSign ? 492 : 72) + 'px' };
    },
    computedWild() {
      return { overflowY: this.openSign ? 'auto' : 'hidden' };
    }
  },
  methods: {
    async init() {
      let res = await getSourceMap();
      if (res.code === '0000') {
        this.orgOptions = res.body;
      }
    },
    initTab1Normal() {
      // this.$refs['morePerTab1'].initNormal();
    },
    computedTitle(item) {
      let reg = /<\/?.+?\/?>/g;
      item.user.name = item.user.name.replace(reg, '');
      if (item.pathName) {
        if (item.pathName) {
          return item.user.name + ' (' + item.pathName + ')';
        }
      } else {
        return item.user.name;
      }
    },
    deleteItem(item) {
      this.selectedList = this.selectedList.filter(inside => {
        return inside.user.userId !== item.user.userId;
      });
    },
    tabChange() {
      this.openSign = false;
    },
    clearSelected() {
      this.selectedList = [];
    },
    selectAllPerFun(items) {
      //全选操作
      let selectListArr = [...this.selectedList];
      items.map(item => {
        let have = false;
        selectListArr.map(inside => {
          if (item.user.userId === inside.user.userId) {
            have = true;
          }
        });
        if (!have) {
          this.selectedList.push(item);
        }
      });
    },
    cancelAllPerFun(items) {
      let selectListArr = [...this.selectedList];
      let newArr = [];
      selectListArr.map(item => {
        let find = false;
        items.map(inside => {
          if (inside.userId == item.userId) {
            find = true;
          }
        });
        if (!find) {
          newArr.push(item);
        }
      });
      this.selectedList = newArr;
    },
    addPersonFun(item) {
      this.selectedList.push(item);
    },
    deletePersonFun(delItem) {
      let arr = [];
      this.selectedList.map(item => {
        if (delItem.user.userId !== item.user.userId) {
          arr.push(item);
        }
      });
      this.selectedList = arr;
    },
    saveBtn() {
      this.handleCollectLastUsedPersonData();
      this.$emit('saveUserDatas', this.selectedList);
    },
    // 最近选择人员数据埋点
    handleCollectLastUsedPersonData() {
      const userId = this.$store.state.user.userData.id;
      const length = this.selectedList.length;
      if (!length) {
        return;
      }
      const choiceIds = this.selectedList.map(selected => selected.user.userId);
      this.$axios.post('/uc/user/choice', { userId, choiceIds });
    },
    handleClose() {
      this.$emit('handleClose');
    },
    openTab() {
      this.openSign = !this.openSign;
    },
    radioSelect(val) {
      if (this.radio) {
        this.selectedList = [val];
      }
    }
  }
};
</script>
<style lang="scss" scope>
.renyuanDialog {
  .dialog-title {
    display: flex;
    justify-content: space-between;

    button {
      float: right;
    }
  }

  .dialog-body {
    position: relative;

    .selectedBox {
      margin: 0px 32px;
      width: 736px;
      position: absolute;
      bottom: 32px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(205, 207, 212, 1);
      z-index: 20;
      transition: height 0.5s;

      .arrowBtn {
        position: absolute;
        background: #fff;
        top: -11px;
        left: 332px;
        display: inline-block;
        width: 60px;
        height: 11px;
        line-height: 11px;
        cursor: pointer;
        z-index: 21;
        text-align: center;
        background-size: 100% 100%;

        i {
          font-size: 12px;
        }
      }

      .arrowBtnUp {
        background: url('../../common/images/expandUp.png') no-repeat;
      }

      .arrowBtnBt {
        background: url('../../common/images/expandBt.png') no-repeat;
      }

      .clearBtn {
        position: absolute;
        right: 3px;
        top: 0px;
        width: 16px;
        height: 16px;
        /*        background: #CDCFD4;*/
        text-align: center;
        line-height: 16px;
      }

      .selectedWild {
        height: 100%;

        .selectedCardBox {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-content: flex-start;
          height: 100%;
          padding: 10px 24px;

          .selectedCardWild {
            width: 50px;
            margin-right: 30px;
            margin-bottom: 15px;
            position: relative;

            .deleIcon {
              display: none;
              position: absolute;
              top: -6px;
              right: -6px;
              font-size: 12px;
              cursor: pointer;
              color: #0a0f13;
              text-align: center;
              border-radius: 50%;
              font-style: normal;
              // position: relative;
              // left:-3px;
            }
          }

          .selectedCardWild:hover {
            cursor: pointer;

            .deleIcon {
              display: inline-block;
              width: 12px;
              height: 12px;
              background: #000;
              color: #fff;
              line-height: 12px;
              text-align: center;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.renyuanDialog {
  .el-dialog__header {
    padding: 10px 20px;
    background: rgba(58, 162, 127, 0.12);
  }

  .el-dialog__body {
    padding: 0px;
  }

  .dialog-body {
    .el-tabs--border-card {
      box-shadow: none;
      border: none;
    }

    .el-tabs__content {
      padding: 0px;
    }
  }
}
</style>
